export default "__VITE_ASSET__7vtqhj1U__"